import { api } from "./client";

export interface RegisterConfig {
  isOpenPhoneVerify: boolean;
  isInviteNecessary: boolean;
}

export interface AppConfig {
  showFinanceMenu: boolean;
  showFundsMenu: boolean;
}

export interface RuntimeValue {
  day: number;
  hour: number;
  minute: number;
  second: number;
  startTimestamp?: number;
  serverTimestamp?: number;
}

const asBoolean = (value: unknown) =>
  value === true || value === 1 || value === "1" || value === "true";

export const configApi = {
  register: async () => {
    const value = await api.get<Record<string, unknown>>("/api/v1/reg/conf");
    return {
      isOpenPhoneVerify: asBoolean(value.isOpenPhoneVerify),
      isInviteNecessary: asBoolean(value.isInviteNecessary),
    } satisfies RegisterConfig;
  },
  sendRegistrationCode: (phone: string) =>
    api.post("/api/v1/send/msg", { phone, type: "1" }),
  app: async () => {
    const value = await api.get<Record<string, unknown>>("/api/v1/app/conf");
    return {
      showFinanceMenu: asBoolean(value.showFinanceMenu),
      showFundsMenu: asBoolean(value.showFundsMenu),
    } satisfies AppConfig;
  },
  runtime: () => api.get<RuntimeValue>("/api/v1/run/tmp"),
  setLanguage: (lang: string) =>
    api.post("/api/v2/def/lang", { lang }),
};
